module.exports = __webpack_public_path__ + "static/media/water.679f3f2f.mov";